// eslint-disable-next-line import/no-extraneous-dependencies
import { get } from 'lodash-es';
import { ActionType } from '../../constants/redux';
import {
	HomeState,
	SetHeaderTitle,
	SetClientId,
	SetClientState,
	SetClientNonce,
	ChangeCurrentForm,
	SetRedirectUrl
} from './types';
import { FORM_OTP, SETUP_PIN } from '../../constants/variables';
import { LoginUser, PreCheckUser } from '../../redux/types';

const INITIAL_STATE: HomeState = {
	headerTitle: '',
	clientId: '',
	clientState: '',
	clientNonce: '',
	redirectUrl:'',
	currentForm:  SETUP_PIN // FORM_LOGIN
};

/**
 * Reducer.
 * @param {state} state -  state.
 * @param {actions} action - One of actions
 * @returns {state}  state object.
 */
const HomeReducer = (state: HomeState = INITIAL_STATE, action: ActionType): HomeState => {
	switch (action.type) {
		case SetHeaderTitle.name: {
			const { payload } = action;
			return {
				...state,
				headerTitle: payload
			};
		}
		case SetClientId.name: {
			const { payload } = action;
			return {
				...state,
				clientId: payload
			};
		}
		case SetClientState.name: {
			const { payload } = action;
			return {
				...state,
				clientState: payload
			};
		}
		case SetClientNonce.name: {
			const { payload } = action;
			return {
				...state,
				clientNonce: payload
			};
		}
		case SetRedirectUrl.name: {
			const { payload } = action;
			return {
				...state,
				redirectUrl: payload
			};
		}
		case ChangeCurrentForm.name: {
			const { payload } = action;
			return {
				...state,
				currentForm: payload
			};
		}
		case PreCheckUser.success: {
			const { data } = action.payload;
			const password_less = get(data, 'password_less', false) || false;
			if (password_less) {
				return {
					...state,
					currentForm: FORM_OTP
				};
			}

			return {
				...state
			};
		}
		case LoginUser.success: {
			const { data } = action.payload;
			const location = get(data, 'redirect_url', '') || '';
			if(location){
				return {
					...state
				};
			}
			return {
				...state,
				currentForm: FORM_OTP
			};
		}
		// case NavigateCode.success: {
		// 	return INITIAL_STATE;
		// }
		default:
			return state;
	}
};

export default HomeReducer;
